/*eslint-disable*/
import React, { useEffect, useState } from 'react'
import { Table, Icon, Header, Button } from 'semantic-ui-react'
import APP_CONSTANTS from '../../../config/constants';
import Axios from 'axios';
import cogoToast from 'cogo-toast';
import LoadingPlaceholder from '../../placeholderComponent/loadingPlaceholder';
import JobcardModal from '../jobcardInfoComponent/jobcardModal';
import moment from 'moment';


const JobcardHistory = (props) => {

    const [jobcardHistory, setJobcardHistory] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [jobcardDataId, setJobcardDataId] = useState('');
    const [openModal, setOpenModal] = useState(false);

    useEffect(() => {
        setIsLoading(true)
        setJobcardHistory([]);
        let vehicleMasterId = props.vehicleHistoryId
        let token = localStorage.getItem('apiToken')
        let userId = localStorage.getItem('userId')
        let customerNo = localStorage.getItem('customerNo')
        let data = JSON.stringify
            ({
                api_token: token,
                customerNo: customerNo,
                vehicleId: vehicleMasterId,
                userId: userId
            })
        Axios.post(`${APP_CONSTANTS.BASE_URL}fleet/jobcard/getJobCards`, data, {
            headers: {
                'Accept': 'application/json',
                "Authorization": localStorage.getItem('apiToken'),
                'Content-Type': 'application/json'
            }
        }).then((response => {
            if (response.data.status === 1) {
                let vehicleInfoArray = response.data.data
                setJobcardHistory(vehicleInfoArray);
                setIsLoading(false);
                let batteryOldSerialNo = vehicleInfoArray.length > 0 ? {
                    productInventoryId: vehicleInfoArray?.[0]?.jb_battery?.productInvId,
                    serialNo: vehicleInfoArray?.[0]?.jb_battery?.serialNo,
                } : "";
                console.log("Testing Vehicle info Array", vehicleInfoArray)
                console.log(response.data)
                props.setFieldValue("batteryDetails.oldSerialNo", batteryOldSerialNo)
                if (response.data.data.length > 0) {
                    props.getLatestHistory(response.data.data)
                    props.setFieldValue("previousMeterReading", response.data.data[0].meterReading)
                    props.setFieldValue("previousMeterReadingCheck", +response.data.data[0].meterReading + 1)
                    // props.setFieldValue("meterReading", +response.data.data[0].meterReading + 1)
                }
            } else {
                setJobcardHistory([]);
                setIsLoading(false);
                props.getLatestHistory(null)
            };
        })).catch(error => {
            console.log(error)
            //error.response ? cogoToast.error(error?.response?.data?.message) : ""
        })
    }, [props.vehicleHistoryId])

    const handleModel = (e, data) => {
        setJobcardDataId(data.jobCardId);
        setOpenModal(true);
    };

    return (
        <>
            {/* {jobcardHistory.length === 0 && isLoading === true && <LoadingPlaceholder />} */}
            {jobcardHistory.length === 0 && isLoading === false ?
                <div className="w3-white ">
                    <div className="pl-3 pad">
                        <Header>No Jobcard History Found</Header>
                    </div>
                </div>
                :
                <>
                    <Table unstackable compact size="small" >
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell colSpan="8"> <label className="labelName w3-text-blue">Vehicle Jobcard History</label></Table.HeaderCell>
                            </Table.Row>
                            <Table.Row >
                                <Table.HeaderCell className="labelName p-bold-600">Jobcard No</Table.HeaderCell>
                                <Table.HeaderCell className="labelName p-bold-600">Jobcard Type</Table.HeaderCell>
                                <Table.HeaderCell className="labelName p-bold-600">Vehicle In Date</Table.HeaderCell>
                                <Table.HeaderCell className="labelName p-bold-600">Vehicle Out Date</Table.HeaderCell>
                                <Table.HeaderCell className="labelName p-bold-600">Meter Reading</Table.HeaderCell>
                                <Table.HeaderCell className="labelName p-bold-600">Total Cost</Table.HeaderCell>
                                <Table.HeaderCell className="labelName p-bold-600">Approval</Table.HeaderCell>
                                <Table.HeaderCell textAlign="right" className="labelName p-bold-600">View</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {jobcardHistory.map((object, index) => (
                                <Table.Row key={index} verticalAlign="middle">
                                    <Table.Cell>{object.jobCardno !== null ? object.jobCardno : ''}</Table.Cell>
                                    <Table.Cell>{object.jb_type !== null ? object.jb_type.jobCardType : ''}</Table.Cell>
                                    <Table.Cell>{object.vehicleInDate !== null ? moment(object.vehicleInDate).format('DD-MM-YYYY') : ''}</Table.Cell>
                                    <Table.Cell>{object.vehicleOutDate !== null ? moment(object.vehicleOutDate).format('DD-MM-YYYY') : ''}</Table.Cell>
                                    <Table.Cell>{object.meterReading !== null ? object.meterReading : ''}</Table.Cell>
                                    <Table.Cell>{object.totalAmt !== null ? object.totalAmt : ''}</Table.Cell>
                                    <Table.Cell className="p-bold-600" >{object.jb_approval_status !== null ? object.jb_approval_status.approvalStatusName : 'Jobcard Created'}</Table.Cell>
                                    <Table.Cell textAlign="right"><Button onClick={(e) => { handleModel(e, object) }} type="button" size="mini" color="blue" icon basic><Icon name="eye" /></Button></Table.Cell>
                                </Table.Row>
                            ))}
                        </Table.Body>
                    </Table>
                    {jobcardDataId ? <JobcardModal spId={jobcardDataId} modalOpen={openModal} handleClose={() => setOpenModal(false)} /> : ''}
                </>
            }

        </>

    );
}

export default JobcardHistory